import { render, staticRenderFns } from "./caigou.vue?vue&type=template&id=1e672dfc&scoped=true"
import script from "./caigou.vue?vue&type=script&lang=js"
export * from "./caigou.vue?vue&type=script&lang=js"
import style0 from "./caigou.vue?vue&type=style&index=0&id=1e672dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e672dfc",
  null
  
)

export default component.exports